<template>
  <custom-popover
    class="mapping-popover"
    ref="popover"
    :style="{ left: popoverPosition.x + 'px', top: popoverPosition.y + 8 + 'px' }"
    @close="$emit('close')"
    :backdrop="true"
  >
    <!-- <div class="variable-selector" :style="{ height: popoverHeight + 'px' }"> -->
    <div class="variable-selector">
      <div class="header">
        <h3>
          {{ $t("ai-sections.mapping-select-variable") }}
        </h3>
        <div class="toggle-advanced">
          <button class="btn btn-xs" :class="{ active: !expressionView }" @click="toggleExpressionView()">
            {{ $t("variable") }}
          </button>
          <button class="btn btn-xs" :class="{ active: expressionView }" @click="toggleExpressionView()">
            Custom
          </button>
        </div>
      </div>
      <variable-selector
        v-if="!expressionView"
        class="variable-list"
        :variable-groups="$store.getters.variableGroups"
        :selected-variable-name="variable ? variable.name : null"
        :show-values="true"
        @variable-name-changed="onVariableNameChanged"
      />
      <div v-else class="advanced-input">
        <textarea
          name="expressionInput"
          id="expressionInput"
          rows="1"
          placeholder="Write text.."
          @input="onInput"
          v-model="expressionValue"
          ref="textarea"
        ></textarea>
        <div class="preview-wrapper custom-scrollbar-light">
          <span class="text-muted text-xs preview-text" v-html="expressionPreview"></span>
        </div>
      </div>
    </div>
    <div class="actions">
      <button @click="$emit('close')">
        {{ $t("ai-sections.mapping-cancel") }}
      </button>
      <button @click="addExpression" :disabled="!selectedVariable && !expressionValue">
        {{ $t("ai-sections.mapping-select") }}
      </button>
    </div>
  </custom-popover>
</template>

<script>
import VariableHelpers from "@/assets/js/variableHelpers.js";
import appHelper from "@/assets/js/appHelper.js";
import CustomPopover from "@/components/CustomPopover";
import VariableSelector from "@/components/VariableSelector";
import debounce from "lodash/debounce";
export default {
  components: {
    VariableSelector,
    CustomPopover
  },
  props: {
    pos: Object,
    expression: String
  },
  data() {
    return {
      selectedVariable: null,
      hasChanges: false,
      popoverPosition: {},
      popoverHeight: {},
      expressionView: false,
      expressionValue: null,
      expressionPreview: null,
      expressionHasError: null,
      expressionError: null,
      getExpressionPreviewDebounce: debounce(() => {
        this.getExpressionPreview();
      }, 500)
    };
  },
  methods: {
    onVariableNameChanged(variableName) {
      this.hasChanges = true;
      this.selectedVariable = { name: variableName, format: "" };
      this.expressionValue = variableName;
      // this.onVariableUpdated()
    },

    checkElementPosition() {
      const bounds = this.$refs.popover.$el.getBoundingClientRect();
      this.popoverHeight = bounds.height;
      this.popoverPosition = this.pos;
      // Ensure that the popover does not open below the screens height
      const windowHeight = window.innerHeight;
      
      if (this.popoverHeight + this.pos.y > windowHeight ) {
        this.$set(this.popoverPosition, "y", this.popoverPosition.y - this.popoverHeight);
      }
    },

    addExpression() {
      // this.$emit("select-variable", this.selectedVariable, this.variable);
      this.$emit("add-expression", this.expressionValue);
    },

    toggleExpressionView() {
      this.expressionView = !this.expressionView;
    },

    onInput(event) {
      this.autoResizeTextarea(event);
      // Get the expression value to show as preview result
      this.getExpressionPreviewDebounce();
    },
    autoResizeTextarea(event) {
      if (!this.expressionView) return;
      appHelper.resizeTextArea(event ? event.target : this.$refs.textarea);
      this.checkElementPosition();
    },
    getExpressionPreview() {
      if (this.expressionValue.length == 0) this.expressionPreview = "Result: No value";
      else {
        this.$store.dispatch("testExpression", this.expressionValue).then((res) => {
          this.expressionHasError = !res.valid;
          const errors = [];
          if (this.expressionHasError) {
            res.tokens.forEach((token) => {
              if (token.tokenType === "Invalid") errors.push(token.error);
            });
          }
          this.expressionPreview = res.result
            ? `Result: ${res.result}`
            : `<span class='text-danger'>Error: Invalid expression statement <br> ${errors.join(", <br>")} </span>`;
        });
      }
    }
  },
  computed: {
    variable() {
      // return the actual variable, not the instance
      if (this.selectedVariable) return this.$store.getters.combinedVariables[this.selectedVariable.name];
      else return null;
    }
  },
  mounted() {
    if (this.expression) {
      this.expressionValue = this.expression;
      if (VariableHelpers.stringIsSingleVariable(this.expression)) {
        this.selectedVariable = {
          name: VariableHelpers.removeFormatting(this.expression),
          format: VariableHelpers.getFormatting(this.expression)
        };
      } else {
        this.expressionView = true;
      }
    }
    this.$nextTick(() => {
      this.autoResizeTextarea();
      this.checkElementPosition();
    });
  }
};
</script>

<style lang="less">
.mapping-popover {
  position: fixed;
  z-index: 102;
  width: 300px;
  .variable-selector {
    border-radius: 10px 10px 0 0;
    padding-top: 0;
    padding-bottom: 4px;
    background: #fff;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .header {
      display: flex;
      justify-content: space-between;
      margin: 12px 20px 0 20px;
      .toggle-advanced {
        // margin: 12px;
      }
    }

    .advanced-input {
      margin: 12px 20px;
      textarea {
        width: 100%;
        border: none;
        border-bottom: 1px solid var(--charcoal-50);
        resize: none;
        outline: none;
      }
    }
  }

  .actions {
    display: flex;
    justify-content: center;
    border-top: 1px solid #3d464a5d;
    border-radius: 0 0 10px 10px;
    background: #fff;
    button {
      transition: 0.1s;
      flex: 1 1 auto;
      border: none;
      background: none;
      padding: 8px 20px;
      color: var(--charcoal);
      &:disabled,
      &:hover {
        opacity: 0.75;
      }
      &:first-of-type {
        border-right: 1px solid #3d464a5d;
      }
    }
  }
  .preview-wrapper {
    max-height: 100px;
    overflow: auto;
  }
  .preview-text {
    word-wrap: break-word;
  }
}
</style>
